import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M4.22998 23.7601C5.52998 24.1301 6.85002 24.2201 8.15002 24.2601C9.45002 24.2701 10.75 24.1601 12.04 23.9501C12.68 23.8401 13.32 23.7301 13.96 23.5601C14.61 23.4401 15.22 23.21 15.86 23.05C16.49 22.87 17.11 22.6401 17.75 22.4401C18.38 22.2301 19 21.97 19.65 21.78C19.1 22.17 18.52 22.5201 17.95 22.8901C17.35 23.1901 16.75 23.53 16.12 23.78C14.87 24.31 13.55 24.7001 12.2 24.9301C10.85 25.1301 9.45998 25.21 8.09998 25.03C6.72998 24.87 5.37998 24.4901 4.22998 23.7601Z"
        fill={outline}
      />
      <path
        d="M53.98 1.52002C53.98 1.52002 55.3 6.31002 53.98 10.27C52.66 14.23 48.21 14.99 51.34 19.35C51.34 19.35 48.04 24.3 40.28 23.48H15.68C7.91999 24.31 4.61999 19.35 4.61999 19.35C7.73999 14.99 3.29998 14.23 1.97998 10.27C0.659977 6.31002 1.97998 1.52002 1.97998 1.52002H53.98Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
